export default __webpack_public_path__ + "static/media/Django.604b1c21.png";